// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_2MnXKix0uHChQCtrBSr0YQ","margin":"_3_N6-GXi5yCK1JV3ojPgNZ","vertical":"_1RllvlY9zSAA43DwXSC0S"};